import React from "react";
import { appHost } from "../../helpers/uri";
import is_null from "../../helpers/is_null";

const PrintSlip = ({ v }) => {
  const _show = () => {
    window.open(`${appHost}/print-acceptance/${v?._id}`, `Student Module Registration Window`, `_parent`, `width=450,height=650`);
  };
  return (
    <button disabled={is_null(v.acceptanceFee) ? true : false} onClick={_show} className="btn btn-info text-white float-right">
      Print Application Slip <i className="fa-solid fa-print"></i>
    </button>
  );
};

export default PrintSlip;
